var FiltersMdl = angular.module( 'FansFilters', ['autocomplete', 'Shared', 'Hues'] );